'use client';

import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {FaqListArea} from '../../components/faq-list-area';

import type {FaqListAreaFragment} from './query';

type Props = {
	data: FaqListAreaFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const FaqListAreaContainer = ({
	data,
	fullWidth,
	anchorHeadings,
	insideToc,
}: Props) => {
	const {contentBlockOptions, heading, faqs} = data;

	if (!faqs?.length) {
		return null;
	}

	return (
		<FaqListArea
			faqs={faqs.map((item) => ({
				question: item.question ?? '',
				_key: item._id,
				answer:
					item.answer && item.answer.length > 0 ? (
						<PortableText value={item.answer} />
					) : null,
				areas: item.areas?.map((area) => area.slug ?? '') ?? [],
				fieldOfAreas:
					item.fieldOfAreas?.map((area) => area.slug ?? '') ?? [],
			}))}
			heading={heading}
			anchorHeadings={anchorHeadings}
			options={{fullWidth, ...contentBlockOptions}}
			insideToc={insideToc}
		/>
	);
};
